import React, { useEffect, useState } from "react";

import Head from "../../layout/head/Head";


import { Form, FormGroup, Spinner, Alert } from "reactstrap";


const Login = (props) => {



    const onFormSubmit = async () => {



        const sendData = {
            Apikey1: props.location.search,
        }

        //console.log(sendData)

        await fetch(process.env.REACT_APP_API_LINK + 'api/Data/Dynamicverify', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(sendData)

        })
            .then(response => response.json())
            .then(
                data => {

                    if (data.firstName !== null) {
                        localStorage.setItem("accessToken", "token");
                        localStorage.setItem('orgId', 1);
                        if (data.urole === 16) {
                            localStorage.setItem('userId', data.userId)
                        } else {
                            localStorage.setItem('userIdmain', data.userId)
                        }


                        localStorage.setItem('Maincatid', data.mainCatID);
                        localStorage.setItem('urole', data.urole);
                        localStorage.setItem('OrderNo', data.orderNo);
                        var page = data.urole === 9 ? (sessionStorage.setItem("Region", data.bloodGroupCatId), "/Reasonal-Dashboard") : data.urole === 7 ? "/DGEDashboard" :
                            data.urole === 8 ? (sessionStorage.setItem("State", data.bloodGroupCatId), "/State-Dashboard") : "/Dashboard";


                        setTimeout(() => {
                            window.history.pushState(
                                `${process.env.PUBLIC_URL ? process.env.PUBLIC_URL : page}`,
                                "auth-login",
                                `${process.env.PUBLIC_URL ? process.env.PUBLIC_URL : page}`
                            );
                            window.location.reload();
                        }, 2000);
                    }

                    else {
                        setTimeout(() => {
                      }, 2000);
                    }




                })
    };

    useEffect(() => {
        onFormSubmit()
    }, [])




    return (
        <React.Fragment>
            <Head title="Check.." />
            <Spinner />
        </React.Fragment>
    );
};
export default Login;
